import { MutationTree } from 'vuex';
import { AuthStoreType } from '@/types/store/auth-store.type';

export const mutations: MutationTree<AuthStoreType> = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
  },
};
